// Vendor
import React from 'react';

// Components
import { Trans, CreditCardIcon } from '../..';

const AddPaymentCard = () => {
  return (
    <div className={'payment-card'}>
      <CreditCardIcon name="blank" />
      <div className="payment-add-text">
        <Trans file="Payment" id="AddCard" fallback="Add Card" />
      </div>
    </div>
  );
};

export default AddPaymentCard;
